import { Colors } from '@/common/colors/colors';

import styled from 'styled-components';

export const Header = styled.h2`
	font-size: 20px;
	color: ${Colors.darkBlue};
	text-align: center;
	font-weight: bold;
	margin-bottom: 30px;
`;

export const Form = styled.form`
	display: flex;
	flex-direction: column;
	align-items: center;
`;
